import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  style: {
    "display": "flex",
    "height": "100%",
    "min-height": "50vh"
  }
};
var _hoisted_2 = {
  class: "search-container"
};
import { useCommonDialog } from '@/component-create/utils/hooks';
import { SearchForm } from '@/component-create/SearchForm';
import { Table } from '@/component-create/Table';

import { ref, watch, nextTick } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'CommonInfoDialog',
  props: {
    title: {},
    defaultSelect: {},
    tabelColunm: {},
    searchItems: {},
    url: {},
    tabelkey: {}
  },
  emits: ['select'],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var dialog = useCommonDialog('userDialog');
    var searchForm = null;
    var table = null;
    var searchFormRef = ref();
    var tableRef = ref();
    watch(function () {
      return props.defaultSelect;
    }, function () {
      if (table) {
        initSysSelect();
      }
    }, {
      immediate: true
    });
    function open() {
      dialog.open();
      if (!table || !searchForm) {
        nextTick(function () {
          renderSearchForm();
          renderTable();
        });
      } else {
        initSysSelect();
      }
    }
    function close() {
      dialog.close();
    }
    /**
     * 绘制搜索表单
     */
    function renderSearchForm() {
      searchForm = new SearchForm(searchFormRef.value, props.searchItems, {
        labelWidth: '80px'
      });
      searchForm.onSearch = function (formData) {
        var _table;
        (_table = table) === null || _table === void 0 || _table.load(formData);
      };
    }
    /**
     * 绘制表格
     */
    function renderTable() {
      table = new Table(tableRef.value, props.tabelColunm, [], {
        border: true,
        rowKey: 'id'
      }, props.url);
      table.onLoaded = function () {
        nextTick(function () {
          initSysSelect();
        });
      };
    }
    function initSysSelect() {
      if (props.defaultSelect) {
        var _table2;
        (_table2 = table) === null || _table2 === void 0 || _table2.setSelectRowKeys(props.defaultSelect, props.tabelkey);
      }
    }
    function confirm() {
      var _table3;
      var selectRows = ((_table3 = table) === null || _table3 === void 0 ? void 0 : _table3.getSelectRows()) || [];
      emits('select', selectRows);
      close();
    }
    function cancel() {
      close();
    }
    __expose({
      open: open,
      close: close
    });
    return function (_ctx, _cache) {
      var _component_XFlexCtx = _resolveComponent("XFlexCtx");
      var _component_ElButton = _resolveComponent("ElButton");
      var _component_XCommonDialog = _resolveComponent("XCommonDialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_XCommonDialog, {
        ref: "userDialog",
        title: _ctx.title,
        width: "70%"
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", null, [_createVNode(_component_ElButton, {
            onClick: cancel
          }, {
            default: _withCtx(function () {
              return _cache[0] || (_cache[0] = [_createTextVNode("取消")]);
            }),
            _: 1
          }), _createVNode(_component_ElButton, {
            type: "primary",
            onClick: confirm
          }, {
            default: _withCtx(function () {
              return _cache[1] || (_cache[1] = [_createTextVNode("确认")]);
            }),
            _: 1
          })])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_XFlexCtx, {
            flex: 1
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
                ref_key: "searchFormRef",
                ref: searchFormRef
              }, null, 512), _createVNode(_component_XFlexCtx, {
                flex: 1
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    style: {
                      "height": "100%"
                    },
                    ref_key: "tableRef",
                    ref: tableRef
                  }, null, 512)];
                }),
                _: 1
              })])];
            }),
            _: 1
          })])];
        }),
        _: 1
      }, 8, ["title"])]);
    };
  }
});